import { IAgentCard, EAgentCardAccountType } from './../../models/agentCard';

export function isRentDepartment({ accountType }: IAgentCard) {
  return accountType === EAgentCardAccountType.RentDepartment;
}
